export default {
    headers: {
        key: {
            id: 'mobileReports.headers.key'
        },
        week: {
            id: 'mobileReports.headers.week'
        },
        imbPatterns: {
            id: 'mobileReports.headers.imbPatterns'
        }
    },
    legends: {
        approximateTime: {
            id: 'mobileReports.legends.approximateTime'
        },
        injection: {
            id: 'mobileReports.legends.injection'
        },
        manualReading: {
            id: 'mobileReports.legends.manualReading'
        },
        twoHoursApartReadings: {
            id: 'mobileReports.legends.twoHoursApartReadings'
        }
    },
    formulas: {},
    labels: {
        from: {
            id: 'mobileReports.labels.from'
        },
        to: {
            id: 'mobileReports.labels.to'
        },
        bgm: {
            id: 'mobileReports.labels.bgm'
        },
        bgmUnit: {
            mgdl: {
                id: 'mobileReports.labels.bgmUnit.mgdl'
            }
        },
        carbs: {
            id: 'mobileReports.labels.carbs'
        },
        carbsUnit: {
            G: {
                id: 'mobileReports.labels.carbsUnit.G'
            }
        },
        injection: {
            id: 'mobileReports.labels.injection'
        },
        injectionUnit: {
            id: 'mobileReports.labels.injectionUnit'
        },
        activity: {
            id: 'mobileReports.labels.activity'
        },
        activityUnit: {
            id: 'mobileReports.labels.activityUnit'
        },
        diaryGeneratedOn: {
            id: 'mobileReports.labels.diaryGeneratedOn'
        },
        pageOf: {
            id: 'mobileReports.labels.pageOf'
        },
        average: {
            id: 'mobileReports.labels.average'
        },
        nReadingsAt: {
            id: 'mobileReports.labels.nReadingsAt'
        }
    },
    summaries: {
        injections: {
            id: 'mobileReports.summaries.injections'
        },
        veryHigh: {
            id: 'mobileReports.summaries.veryHigh'
        },
        veryLow: {
            id: 'mobileReports.summaries.veryLow'
        },
        standardDeviation: {
            id: 'mobileReports.summaries.standardDeviation'
        },
        persentOfReadingsInRange: {
            id: 'mobileReports.summaries.persentOfReadingsInRange'
        },
        averagePreMeal: {
            id: 'mobileReports.summaries.averagePreMeal'
        },
        averageStrictPostMeal: {
            id: 'mobileReports.summaries.averageStrictPostMeal'
        },
        averageOverall: {
            id: 'mobileReports.summaries.averageOverall'
        },
        dailySummary: {
            id: 'mobileReports.summaries.dailySummary'
        },
        average: {
            id: 'mobileReports.summaries.average'
        }
    },
    glucoseReport: {
        afterMealTarget: {
            id: 'mobileReports.glucoseReport.afterMealTarget'
        },
        beforeMealTarget: {
            id: 'mobileReports.glucoseReport.beforeMealTarget'
        },
        title: {
            id: 'mobileReports.glucoseReport.title'
        },
        dateOfBirth: {
            id: 'mobileReports.glucoseReport.dateOfBirth'
        },
        preMealRange: {
            id: 'mobileReports.glucoseReport.preMealRange'
        },
        postMealRange: {
            id: 'mobileReports.glucoseReport.postMealRange'
        },
        correctRange: {
            id: 'mobileReports.glucoseReport.correctRange'
        },
        readings: {
            id: 'mobileReports.glucoseReport.readings'
        },
        tableDays: {
            id: 'mobileReports.glucoseReport.tableDays'
        },
        tableAutomaticReadings: {
            id: 'mobileReports.glucoseReport.tableAutomaticReadings'
        },
        tableManualReadings: {
            id: 'mobileReports.glucoseReport.tableManualReadings'
        },
        tableReadingsPerDay: {
            id: 'mobileReports.glucoseReport.tableReadingsPerDay'
        },
        tableAveragePreMeal: {
            id: 'mobileReports.glucoseReport.tableAveragePreMeal'
        },
        tableAveragePostMeal: {
            id: 'mobileReports.glucoseReport.tableAveragePostMeal'
        },
        tableStandardDeviation: {
            id: 'mobileReports.glucoseReport.tableStandardDeviation'
        },
        tableRange: {
            id: 'mobileReports.glucoseReport.tableRange'
        },
        tableVariability: {
            id: 'mobileReports.glucoseReport.tableVariability'
        },
        generatedReport: {
            id: 'mobileReports.glucoseReport.generatedReport'
        },
        headerGlucoseLevelHeader: {
            id: 'mobileReports.glucoseReport.headerGlucoseLevelHeader'
        },
        bloodGlucoseAbove: {
            id: 'mobileReports.glucoseReport.bloodGlucoseAbove'
        },
        bloodGlucoseBelow: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBelow'
        },
        bloodGlucoseInTarget: {
            id: 'mobileReports.glucoseReport.bloodGlucoseInTarget'
        },
        headerBloodGlucoseHeader: {
            id: 'mobileReports.glucoseReport.headerBloodGlucoseHeader'
        },
        bloodGlucoseBottom: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBottom'
        },
        bloodGlucoseBottomUnmarkedReadings: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBottomUnmarkedReadings'
        },
        headerBloodGlucoseHeaderPreMeal: {
            id: 'mobileReports.glucoseReport.headerBloodGlucoseHeaderPreMeal'
        },
        bloodGlucoseBottomPreMeal: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBottomPreMeal'
        },
        headerBloodGlucoseHeaderPostMeal: {
            id: 'mobileReports.glucoseReport.headerBloodGlucoseHeaderPostMeal'
        },
        bloodGlucoseBottomPostMeal: {
            id: 'mobileReports.glucoseReport.bloodGlucoseBottomPostMeal'
        },
        textField: {
            id: 'mobileReports.glucoseReport.textField'
        },
        criticalLow: {
            id: 'mobileReports.glucoseReport.criticalLow'
        },
        criticalHigh: {
            id: 'mobileReports.glucoseReport.criticalHigh'
        },
        low: {
            id: 'mobileReports.glucoseReport.low'
        },
        high: {
            id: 'mobileReports.glucoseReport.high'
        },
        diabetesType: {
            id: 'mobileReports.glucoseReport.diabetesType'
        },
        manuallyEnteredReading: {
            id: 'mobileReports.glucoseReport.manuallyEnteredReading'
        },
        treatmentType: {
            id: 'mobileReports.glucoseReport.treatmentType'
        },
        reportGeneratedOn: {
            id: 'mobileReports.glucoseReport.reportGeneratedOn'
        },
        tableCriticalHigh: {
            id: 'mobileReports.glucoseReport.tableCriticalHigh'
        },
        tableCriticalLow: {
            id: 'mobileReports.glucoseReport.tableCriticalLow'
        }
    },
    dailyReport: {
        tableCriticalHigh: {
            id: 'mobileReports.dailyReport.tableCriticalHigh'
        },
        tablePostMeal: {
            id: 'mobileReports.dailyReport.tablePostMeal'
        },
        tablePreMeal: {
            id: 'mobileReports.dailyReport.tablePreMeal'
        },
        tableCriticalLow: {
            id: 'mobileReports.dailyReport.tableCriticalLow'
        },
        standardDay: {
            id: 'mobileReports.dailyReport.standardDay'
        }
    },
    infos: {
        noimbPatterns: {
            id: 'mobileReports.infos.noimbPatterns'
        }
    },
    kpi: {}
};
